import { WidgetConfig } from "@/PageComponents/Dashboard/DashboardModels";
import { FC } from "react";

const SCJobTrackerWidget: FC<{
    onDismiss: (() => void) | undefined
    widget: WidgetConfig
}> = ({ onDismiss, widget }: any) => {


    return (<>
        {widget.friendlyID}
    </>);
};

export default SCJobTrackerWidget;